// @flow

import styled from "styled-components";
import * as size from "src/styles/constants/size";

export const FormHeading = styled.h4`
  margin: 0;
  margin-top: 0.3em;
`;

export const ApprovalTypeInfo = { minWidth: 0, maxWidth: "15rem" };

export const PicklistValue = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  word-break: break-word;
`;

export const Name = styled.span`
  font-size: ${size.fontSize.small};
  line-height: 1.25rem;
  width: 12.8em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ChecklistBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  > p {
    margin: 0px;
  }

  overflow: hidden;
`;

export const ChecklistField = styled.div`
  display: flex;
  input,
  label {
    cursor: default !important;
  }
`;

export const LinkedFieldValues = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  > *::after {
    content: ",";
  }
  > *:last-child::after {
    content: "";
  }
`;

export const ChecklistFieldLabel = styled.span`
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
